import api from '../../../api';
// Simulated data
let rateData = [
  {
    id: 1,
    services: 'Certification',
    standard: 'ISO 27001',
    productCategory: 'Information Security',
    level: 'Enterprise',
    serviceItem: 'Initial Certification',
    unitType: 'Mandays',
    priceSettings: [
      {
        priceListRange: '1-50 employees',
        rateTo: '$5,000',
        workflow: 'Standard Approval'
      },
      {
        priceListRange: '51-200 employees',
        rateTo: '$8,000',
        workflow: 'Standard Approval'
      },
      {
        priceListRange: '201+ employees',
        rateTo: '$12,000',
        workflow: 'Special Approval'
      }
    ]
  },
  {
    id: 2,
    services: 'Training',
    standard: 'ISO 9001',
    productCategory: 'Quality Management',
    level: 'Professional',
    serviceItem: 'Internal Auditor Training',
    unitType: 'Package',
    priceSettings: [
      {
        priceListRange: 'Basic Package',
        rateTo: '$2,500',
        workflow: 'Training Approval'
      },
      {
        priceListRange: 'Premium Package',
        rateTo: '$4,000',
        workflow: 'Training Approval'
      }
    ]
  },
  {
    id: 3,
    services: 'Audit',
    standard: 'ISO 45001',
    productCategory: 'Safety Management',
    level: 'Basic',
    serviceItem: 'Gap Analysis',
    unitType: 'Hours',
    priceSettings: [
      {
        priceListRange: '1-20 hours',
        rateTo: '$1,800',
        workflow: 'Audit Approval'
      },
      {
        priceListRange: '21-40 hours',
        rateTo: '$3,200',
        workflow: 'Audit Approval'
      }
    ]
  }
];

// Simulate API delay
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// API functions
export const fetchRates = async ({ page = 0, size = 10, search = '', service = '', standard = '', productCategory = '', serviceItem = '' } = {}) => {
  const hasFilters = search || service || standard || productCategory || serviceItem;

  if (hasFilters) {
    // Try server-side filter endpoint first; if not deployed yet (404) fall back to full list
    try {
      const params = new URLSearchParams();
      params.set('page', String(page));
      params.set('size', String(size));
      if (search) params.set('search', search);
      if (service) params.set('service', service);
      if (standard) params.set('standard', standard);
      if (productCategory) params.set('productCategory', productCategory);
      if (serviceItem) params.set('serviceItem', serviceItem);
      const res = await api.get(`/crm/rates/filter?${params.toString()}`);
      return res.data;
    } catch (e) {
      if (e?.response?.status !== 404) throw e;
      // 404 = endpoint not yet deployed; fall through to full-list fetch below
    }
  }

  // No filters (or filter endpoint not available).
  // Try paginated endpoint first; if it returns a flat array (old backend), fetch all so the
  // client-side fallback in loadRates has the full dataset to filter and paginate.
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('size', String(size));
  const res = await api.get(`/crm/rates?${params.toString()}`);
  const data = res.data;

  // Old backend returns flat array — re-fetch without pagination to get everything
  if (Array.isArray(data)) {
    const allRes = await api.get('/crm/rates');
    return allRes.data;
  }

  return data;
};

export const getRateById = async (id) => {
  await delay(300);
  return rateData.find(rate => rate.id === id);
};

export const updateRate = async (id, updatedData) => {
  const standardIds = Array.isArray(updatedData.standardIds)
    ? updatedData.standardIds.map(Number)
    : Array.isArray(updatedData.standardId)
      ? updatedData.standardId.map(Number)
      : [];

  const serviceItemIds = Array.isArray(updatedData.serviceItemIds)
    ? updatedData.serviceItemIds.map(Number)
    : Array.isArray(updatedData.serviceItemId)
      ? updatedData.serviceItemId.map(Number)
      : [];

  const payload = {
    ...updatedData,
    standardIds,
    serviceItemIds,
    priceSettings: updatedData.priceSettings.map(ps => ({
      rateFrom: ps.rateFrom ? Number(ps.rateFrom) : null,
      rateTo: ps.rateTo ? Number(ps.rateTo) : null,
      workFlowId: ps.workFlowId
    }))
  };

  delete payload.standardId;
  delete payload.serviceItemId;

  const res = await api.put(`/crm/rates/${id}`, payload);
  return res.data;
};

// export const createRate = async (newData) => {
//   // mapping jika perlu, misal standardId dan serviceItemId hanya kirim id (bukan object)
//   console.log('Payload Save Data')
//   console.log(JSON.stringify(newData))
//   const payload = {
//     ...newData,
//     standardId: Array.isArray(newData.standardId) ? newData.standardId.join(',') : newData.standardId,
//     serviceItemId: Array.isArray(newData.serviceItemId) ? newData.serviceItemId.join(',') : newData.serviceItemId,
//     priceSettings: newData.priceSettings.map(ps => ({
//       ...ps,
//       rateFrom: ps.rateFrom ? Number(ps.rateFrom) : null,
//       rateTo: ps.rateTo ? Number(ps.rateTo) : null,
//       workFlowId: ps.workFlowId
//     }))
//   };
//   const res = await api.post('/crm/rates', payload);
//   return res.data;
// };

export const createRate = async (newData) => {
  const standardIds = Array.isArray(newData.standardIds)
    ? newData.standardIds.map(Number)
    : Array.isArray(newData.standardId)
      ? newData.standardId.map(Number)
      : [];

  const serviceItemIds = Array.isArray(newData.serviceItemIds)
    ? newData.serviceItemIds.map(Number)
    : Array.isArray(newData.serviceItemId)
      ? newData.serviceItemId.map(Number)
      : [];

  const payload = {
    ...newData,
    standardIds,
    serviceItemIds,
    priceSettings: newData.priceSettings.map(ps => ({
      rateFrom: ps.rateFrom ? Number(ps.rateFrom) : null,
      rateTo: ps.rateTo ? Number(ps.rateTo) : null,
      workFlowId: ps.workFlowId
    }))
  };

  delete payload.standardId;
  delete payload.serviceItemId;

  const res = await api.post('/crm/rates', payload);
  return res.data;
};


export const deleteRate = async (id) => {
  const res = await api.delete(`/crm/rates/${id}`);
  return res.data;
}; 

export const fetchServiceOptions = async () => {
  const res = await api.get('/crm/services/options');
  return res.data;
};

export const fetchUnitTypeOptions = async () => {
  const res = await api.get('/crm/type-units');
  return res.data;
};

export const fetchWorkflowOptions = async () => {
  const res = await api.get('/crm/workflows');
  return res.data;
};

export const fetchStandardsByServiceId = async (serviceId) => {
  if (!serviceId) return [];
  const res = await api.get(`/crm/standards/by-service/${serviceId}`);
  return res.data;
};

export const fetchServiceItemsByStandardId = async (standardIds) => {
  if (!standardIds || standardIds.length === 0) return [];
  const res = await api.get(`/md/audit-type/by-standard`, {
    params: { standardIds },
    paramsSerializer: params => {
      const searchParams = new URLSearchParams();
      for (const key in params) {
        if (Array.isArray(params[key])) {
          params[key].forEach(value => {
            searchParams.append(key, value);
          });
        } else {
          searchParams.append(key, params[key]);
        }
      }
      return searchParams.toString();
    }
  });
  return res.data;
};

export const fetchStandardOptions = async () => {
  await delay(200);
  return [
    { id: 'iso27001', name: 'ISO 27001' },
    { id: 'iso9001', name: 'ISO 9001' },
    { id: 'iso45001', name: 'ISO 45001' },
    { id: 'iso14001', name: 'ISO 14001' }
  ];
};

export const cloneRatesByService = async (sourceServiceId, targetServiceId) => {
  const payload = {
    sourceServiceId: sourceServiceId,
    targetServiceId: targetServiceId
  };
  
  const res = await api.post('/crm/rates/clone-by-service', payload);
  return res.data;
}; 